import React from 'react';
import { BookOpen, ChevronDown, GraduationCap } from 'lucide-react'; // Добавлен GraduationCap
import { formatDisplayDate } from '../utils/formatters';


const MaterialsList = ({ 
  user, 
  getUserTrainingsList, 
  getUserCoursesList, 
  trainingsMap, 
  coursesMap, 
  expandedMaterials, 
  toggleMaterialsExpand,
  getTrainingAccess,
  getCourseAccess 
}) => {
  const trainings = getUserTrainingsList(user);
  const courses = getUserCoursesList(user);
  const hasMaterials = trainings.length > 0 || courses.length > 0;
  const isExpanded = expandedMaterials[user.id];
  
  const getTrainingTitle = (trainingId) => {
    return trainingsMap[trainingId] || trainingId.substring(0, 8) + '...';
  };

  const getCourseTitle = (courseId) => {
    return coursesMap[courseId] || courseId.substring(0, 8) + '...';
  };
  
  if (!hasMaterials) {
    return (
      <div className="text-xs text-gray-500">
        Нет доступа
      </div>
    );
  }
  
  return (
    <div className="relative">
      <button
        onClick={() => toggleMaterialsExpand(user.id)}
        className="flex items-center gap-1 text-xs text-blue-400 hover:text-blue-300 transition-colors"
      >
        <BookOpen className="w-3 h-3" />
        <span>{trainings.length + courses.length} материалов</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
      </button>
      
      {isExpanded && (
        <div className="absolute z-[100] mt-1 w-80 bg-gray-800 rounded-lg shadow-xl border border-gray-700 p-2 max-h-80 overflow-y-auto">
          {trainings.length > 0 && (
            <div className="mb-2">
              <div className="text-xs font-semibold text-purple-400 mb-1 flex items-center gap-1">
                <BookOpen className="w-3 h-3" />
                Тренинги ({trainings.length})
              </div>
              <div className="space-y-1">
                {trainings.map(trainingId => {
                  const access = getTrainingAccess(trainingId, user.trainingsAccess);
                  const isExpired = access ? new Date(access.endDate) < new Date() : false;
                  return (
                    <div key={trainingId} className="text-xs text-gray-300 flex items-start gap-1">
                      <span className="text-purple-400">•</span>
                      <span className={isExpired ? 'text-red-400 line-through' : ''}>
                        {getTrainingTitle(trainingId)}
                      </span>
                      {access?.startDate && access?.endDate && !isExpired && (
                        <span className="text-gray-500 text-xs ml-1">
                          ({formatDisplayDate(access.startDate)} - {formatDisplayDate(access.endDate)})
                        </span>
                      )}
                      {isExpired && (
                        <span className="text-red-400 text-xs ml-1">(истек)</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          
          {courses.length > 0 && (
            <div>
              <div className="text-xs font-semibold text-green-400 mb-1 flex items-center gap-1">
                <GraduationCap className="w-3 h-3" />
                Курсы ({courses.length})
              </div>
              <div className="space-y-1">
                {courses.map(courseId => {
                  const access = getCourseAccess(courseId, user.coursesAccess);
                  return (
                    <div key={courseId} className="text-xs text-gray-300 flex items-start gap-1">
                      <span className="text-green-400">•</span>
                      <span>{getCourseTitle(courseId)}</span>
                      {access?.startDate && access?.endDate && (
                        <span className="text-gray-500 text-xs ml-1">
                          ({formatDisplayDate(access.startDate)} - {formatDisplayDate(access.endDate)})
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MaterialsList;